'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Card, Form, Button } from 'react-bootstrap';

import ErrorBox from '../common/ErrorBox';
import SuccessBox from '../common/SuccessBox';
import SingleAssetInput from '../common/SingleAssetInput'

const AssetUtil = require('../../util/asset');
const OrganizationActions = require('../../actions/OrganizationActions');
const OrganizationStore = require('../../stores/OrganizationStore');
import SortableTableClassic from '../table/SortableTableClassic';

const propTypes = {
    org_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
const defaultProps = {};

const SKETCH_COLUMN_DATA = [
    {
        displayName: 'Name',
        key:'name',
        size: 2,
        type: 'string'
    },
    {
        displayName: 'Date',
        key:'date',
        size: 1,
        type: 'date'
    },
    {
        displayName: 'Sketch URL',
        key:'sketch_url',
        size: 7,
        type: 'string'
    },
];


class AdminOrgWebSketchUploads extends React.Component {
    constructor(props) {
        super(props);
        
        const orgStoreState = OrganizationStore.getStateOrganization(props.org_id);
        this.state = {
            orgStoreState
        };
        this.unsubscribes = [
            OrganizationStore.listen(this.onOrgStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        if (!this.state.orgStoreState.orgJsonAssets) {
            let getAssetActionId = uuid.v4();
            this.setState({getAssetActionId},()=>{
                OrganizationActions.getOrgJsonAssets(getAssetActionId, this.props.org_id);
            });
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onOrgStoreChange=(orgStoreState)=>{
        let stateChanges = {
            orgStoreState: OrganizationStore.getStateOrganization(this.props.org_id)
        };
        if (orgStoreState.action) {
            let error;
            if (orgStoreState.action.id === this.state.getAssetActionId) {
                stateChanges.getAssetActionId = null;
                error = orgStoreState.action.error;
            }
            if (orgStoreState.action.id === this.state.uploadActionID) {
                stateChanges.uploadActionID = null;
                error = orgStoreState.action.error;
            }
            if (error) {
                stateChanges.error = orgStoreState.action.error;
            }
        }
        this.setState(stateChanges);
    }

    uploadSketch=(params, files)=>{
        const uploadActionID = uuid.v4();
        this.setState({uploadActionID}, ()=>{
            OrganizationActions.addOrgAsset(
                uploadActionID,
                {
                    ...params,
                    org_id: this.props.org_id,
                },
                files
            );
        });
    }

    uploadError=(errorMessage)=>{
        this.setState({hasError: true, message: errorMessage});
        //alert("Asset upload failed! "+errorMessage);
    }

    copyToClipboard=(evt)=>{
        let element = evt.target;
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val($(element).text()).select();
        document.execCommand("copy");
        $temp.remove();
    }

    onSketchClick=(e, sketchIndex)=>{
        console.log("onSketchClick",sketchIndex);
    }
    
    render() {
        // static page which can render webscript graphs from s3
        const webscript_page = "https://client-cdn.muzzylane.com/sfc/editor/4.5.8/lib/webscript_page.html"; // spork feature-graph-tool-experimentation
        const jsonAssets = this.state.orgStoreState.orgJsonAssets || [];
        const sketch_variable = (GlobalConfig.AssetStoreUrl.indexOf('asset-store-dev') >= 0) ? 'hash' : 'sk'; // tell webscript page which asset store
        
        return (
            <Card body bg="light">
                <Form>
                    <SingleAssetInput
                        useLink
                        browseText="Upload WebSketch JSON File"
                        assetType="json"
                        assetRole="default"
                        accept="application/JSON"
                        onChange={this.uploadSketch}
                        onError={this.uploadError}
                        validateAssetType={AssetUtil.validateJsonMimeType}
                        disabled={!!this.state.uploadActionID }
                    />
                    <ErrorBox error={this.state.error} />
                    <br/>
                </Form>
                <SortableTableClassic
                    onRowClick={this.onSketchClick}
                    rows={jsonAssets.map((row,index)=>{
                        let txt = row.url;
                        let parts = txt.split('/');
                        let last_part = parts[parts.length-1];
                        let p2 = last_part.split('.');
                        let hash = p2[0];
                        let k = 'hash'
                        let sketch_url = `${webscript_page}?${sketch_variable}=${hash}`;
                        return {
                            index: index,
                            name: row.name,
                            sketch_url: (<span onClick={this.copyToClipboard} title="click to copy to clipboard">{sketch_url}</span>),
                            date: row.date
                        }
                    })}
                    selectedRowKey={this.state.selectedSketch ? this.state.selectedSketch.index : null}
                    dateFormat="YYYY-MM-DD HH:mm:ss"
                    columns={SKETCH_COLUMN_DATA}
                />
            </Card>
        );
    }
}

AdminOrgWebSketchUploads.propTypes = propTypes;
AdminOrgWebSketchUploads.defaultProps = defaultProps;

export default AdminOrgWebSketchUploads;
